import {isNotNil} from 'ramda';

import type {AppSyncErrorPayload} from '../types';

export const extractAppSyncErrorMessage = (payload: AppSyncErrorPayload) => {
  const [first] = payload.errors;

  if (isNotNil(first)) {
    const prefix = isNotNil(first.errorType) ? `${first.errorType}: ` : '';
    return `AppSync error: ${prefix}${first.message}`;
  }

  return 'AppSync error: unknown error payload';
};
